import { FAQ, FAQList } from '@st/theme'
import { ReactNode } from 'react'

export function STPricingFAQList() {
  return (
    <Accordion className="w-2/3">
      <AccordionItem title="How much does StanfordTax cost?">
        StanfordTax costs $18 per return. StanfordTax strives for fair pricing. You only pay for
        what you use.
      </AccordionItem>

      <AccordionItem title="How does StanfordTax count usage?">
        Usage is only counted when one or more documents are uploaded to a return.
        <br />
        For example, if you import 500 clients but only 100 of them contain documents, you'll only
        be charged for 100 returns.
      </AccordionItem>

      <AccordionItem title="What if I pay for more than what I end up using?">
        Unused credits will roll over to the next year.
      </AccordionItem>

      <AccordionItem title="Can I try it out for free?">
        Yes! When you sign up, you'll get 5 free credits which you can use toward 5 returns.
      </AccordionItem>

      <AccordionItem title="Are there any implementation or onboarding fees?">
        StanfordTax does not have any implementation or onboarding fees because of how simple it is
        to set up. You can schedule a free 30-minute onboarding session once you upgrade your
        account.
      </AccordionItem>
    </Accordion>
  )
}

function Accordion({ children, className }: { children: ReactNode; className?: string }) {
  return <FAQList className={className}>{children}</FAQList>
}

function AccordionItem({ title, children }: { title: string; children: ReactNode }) {
  return <FAQ title={title}>{children}</FAQ>
}
